<template>
    <cmpTableWithMenu v-bind:name="name" 
        v-bind:pkColumn="pkColumn"
        v-bind:fields="fields" 
        v-bind:qryFields="qryFields" 
        v-bind:children="children"
        v-bind:parent="parent"
        v-bind:header="header"
        v-bind:tableFuncs="tableFuncs"
        v-bind:moreTableFuncs="moreTableFuncs"></cmpTableWithMenu>
</template>

<script>
    import cmpTableWithMenu from "@/components/common/cmpTableWithMenu"
    import i18n from '@/i18n'

    export default {
        components: {
            cmpTableWithMenu
        },
        computed: {
            fields() {
                return [
                    { "key": "Operation", "label": i18n.t('component.operation'), tdClass: 'text-center', thClass: 'text-center' },
                    { "key": "No", "label": "No." },
                    { "key": "Name", "label": i18n.t('component.Code.Name.label'), sortable: true },
                    { "key": "DisplayName", "label": i18n.t('component.Code.DisplayName.label'), sortable: true },
                ]
            },
            qryFields() {
                return [
                    { "key": "Name", "label": i18n.t('component.Code.Name.label'), input: { type: "text" } },
                    { "key": "DisplayName", "label": i18n.t('component.Code.DisplayName.label'), input: { type: "text" } },
                ]
            },
            header() {
                return i18n.t('component.Code.lstHeader')
            }
        },
        data() {
            return {
                name: "Code",
                pkColumn: "CodeId",
                parent: {},
                tableFuncs: ['rec', 'copyNew', 'edit', 'delete'],
                moreTableFuncs: [{ key: "BtnCodeCodeDetail", icon: "IcnGo.png", tooltip: i18n.t('component.Code.CodeDetail.label'), function: { type: 'route', name: "lstCodeDetail", key: "CodeId", queryString: ['CodeId'] } }]

            };
        }
    }
</script>